import Vue from "vue";
import { cloneDeep } from "lodash";
import { imagesStateStore } from "@/services/indexedDB.service";

import { stripTimestampAndExtension } from "@/assets/js/Utilities";
// import { blocks, lutify, UI } from '@/assets/js/Boot';

const getDefaultState = () => {
	return {
		projectTreeUpdateAll: null,
		projectTree: [],
		initialProjectTreeRefresh: true,
		copyToProjectTree: [],
		copyCandidateFromProjectTree: [],
		applyGradeToProjectTree: [],
		applyGradeFromCandidateProjectTree: [],
		applyGradeFromMatchProjectTree: [],
		modalImagesProjectTree: [],
		projects: [],
		projectsFeaturedImage: {},
		project: {
			name: "",
			folders: [],
		},
		project_id: null,
		modalSelectedProject: null,
		projectSettings: {
			id: null,
		},
		deletingProjects: [],
		bin: {
			id: null,
		},
		previousBin: {
			id: null,
		},
		lastProject: null,
		files: null,
		image: null,
		currentFile: null,
		previousFile: {},
		match: {
			id: null,
		},
		candidate: null,
		action: {
			type: null,
			action: null,
			id: null,
			data: null,
		},
		imagesStoreList: [],
		imagesUploadList: [],
		imagesUploadProgress: [],
		totalImagesUploadSize: null,
		uploadStatus: null,
		totalUploadFiles: null,
		filesUploaded: 0,
		processedFilesForUpload: 0,
		imageUploadResponses: [],
		failedUploadsList: [],
		matchesUploadList: [],
		matchesStoreList: [],
		candidatesUploadList: [],
		fileThumbnailObjects: {},
		commentUploadList: [],
		openProjectTree: [],
		lastOpenProjectTree: [],
		allOpenProjectTree: false,
		tags: {
			status: [
				{
					label: "No status",
					value: "no_status",
					styleColor: "#989898",
				},
				{
					label: "In progress",
					value: "in_progress",
					styleColor: "yellow",
				},
				{
					label: "Needs review",
					value: "need_review",
					styleColor: "blue",
				},
				{
					label: "Needs revision",
					value: "need_revision",
					styleColor: "orange",
				},
				{
					label: "Approved",
					value: "approved",
					styleColor: "green",
				},
			],
			rating: [
				{
					label: "None",
					value: "none",
				},
				{
					value: 1,
				},
				{
					value: 2,
				},
				{
					value: 3,
				},
				{
					value: 4,
				},
				{
					value: 5,
				},
			],
			color: [
				{
					label: "None",
					value: "none",
					styleColor: "#989898",
				},
				{
					label: "Red",
					value: "red",
					styleColor: "red",
				},
				{
					label: "Orange",
					value: "orange",
					styleColor: "orange",
				},
				{
					label: "Yellow",
					value: "yellow",
					styleColor: "yellow",
				},
				{
					label: "Green",
					value: "green",
					styleColor: "green",
				},
				{
					label: "Blue",
					value: "blue",
					styleColor: "blue",
				},
				{
					label: "Pink",
					value: "pink",
					styleColor: "pink",
				},
				{
					label: "Purple",
					value: "purple",
					styleColor: "purple",
				},
			],
		},
		projectTreeSearch: "*",
		appliedFilters: [],
		selectedProject: null,
		channelToken: null,
		// channels: [],
		neuralFilmAIUnprocessedList: [],
		neuralFilmAIProcessingFile: '',
		saveAllAsCandidatesUnprocessedList: [],
		saveAllAsCandidatesProcessingFile: '',
		exif: {
			width: null,
			height: null
		}
	};
};

const Projects = {
	namespaced: true,
	state: getDefaultState(),
	mutations: {
		SET_PROJECT_TREE: (state, payload) => {
			state.projectTree = payload;
		},
		SET_INITIAL_PROJECT_TREE_REFRESH: (state, payload) => {
			state.initialProjectTreeRefresh = payload;
		},
		SET_COPY_TO_PROJECT_TREE: (state, payload) => {
			state.copyToProjectTree = payload;
		},
		SET_COPY_CANDIDATE_FROM_PROJECT_TREE: (state, payload) => {
			state.copyCandidateFromProjectTree = payload;
		},
		SET_APPLY_GRADE_TO_PROJECT_TREE: (state, payload) => {
			state.applyGradeToProjectTree = payload;
		},
		SET_APPLY_GRADE_FROM_CANDIDATE_PROJECT_TREE: (state, payload) => {
			state.applyGradeFromCandidateProjectTree = payload;
		},
		SET_APPLY_GRADE_FROM_MATCH_PROJECT_TREE: (state, payload) => {
			state.applyGradeFromMatchProjectTree = payload;
		},
		SET_MODAL_IMAGES_PROJECT_TREE: (state, payload) => {
			state.modalImagesProjectTree = payload;
		},
		SET_PROJECTS: (state, projects) => {
			state.projects = projects.reverse();
		},
		SET_SELECTED_PROJECT: (state, selectedProject) => {
			state.selectedProject = selectedProject;
		},
		SET_SELECTED_PROJECT_ID: (state, id) => {
			state.project_id = id;
		},
		SET_ACTIVE_PROJECT: state => {
			state.project = state.projects.find(project => project.id == state.project_id);
		},
		SET_BIN: (state, payload) => {
			state.bin = payload;
		},
		SET_PREVIOUS_BIN: state => {
			state.previousBin = state.bin;
		},
		SET_PROJECT_SETTINGS: (state, id) => {
			state.projectSettings = state.projects.find(project => project.id == id);
		},
		PROJECT_CREATED: () => {
		},
		PROJECT_NAME_UPDATED: () => {
		},
		USERS_REMOVED: () => {
		},
		USERS_ASSIGNED: () => {
		},
		GROUPS_REMOVED: () => {
		},
		GROUPS_ASSIGNED: () => {
		},
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
		RESET_ACTIVE_BIN: state => {
			state.bin = getDefaultState().bin;
		},
		CREATE_BIN: () => {
		},
		BIN_UPDATED: () => {
		},
		BIN_DELETED: () => {
		},
		FILE_NAME_UPDATED: () => {
		},
		SET_FILES: (state, files) => {
			state.files = files;
		},
		SET_IMAGE: (state, payload) => {
			state.image = payload;
		},
		SET_CURRENT_FILE: (state, payload) => {
			state.currentFile = payload;
		},
		SET_PREVIOUS_FILE: state => {
			state.previousFile = state.currentFile;
		},
		SET_ACTION: (state, payload) => {
			if (!payload.data) payload.data = state.projectTree.find(bin => bin.id == payload.id);
			state.action = payload;
		},
		FECTH_SYSTEM_LUTS: () => {
		},
		FILE_DELETED: () => {
		},
		MOVED_TO: () => {
		},
		POST_CANDIDATES_DATA: () => {
		},
		SELECT_MATCH: (state, payload) => {
			state.match = payload;
		},
		DESELECT_MATCH: state => {
			state.match = { id: null };
		},
		SET_CANDIDATE: (state, id) => {
			state.candidate = id;
		},
		SET_IMAGES_UPLOAD_LIST: (state, payload) => {
			state.imagesUploadList = payload;
		},
		SET_IMAGES_STORE_LIST: (state, payload) => {
			state.imagesStoreList = payload;
		},

		SET_MATCHES_STORE_LIST: (state, payload) => {
			state.matchesStoreList = payload;
		},

		SET_FILE_THUMBNAIL_OBJECT: (state, payload) => {
			Vue.set(state.fileThumbnailObjects, payload.file_id, payload.objectURL);
		},

		REVOKE_FILE_THUMBNAIL_OBJECT: (state, payload) => {
			if (state.fileThumbnailObjects[payload]) URL.revokeObjectURL(state.fileThumbnailObjects[payload]);
		},

		REVOKE_THUMBNAIL_OBJECTS: state => {
			Object.keys(state.fileThumbnailObjects).forEach(key => URL.revokeObjectURL(state.fileThumbnailObjects[key]));
			state.fileThumbnailObjects = [];
		},

		SET_COMMENT_UPLOAD_LIST: (state, payload) => {
			state.commentUploadList = payload;
		},

		SET_MATCHES_UPLOAD_LIST: (state, payload) => {
			state.matchesUploadList = payload;
		},

		// UPDATE_MATCH: (state, payload) => {
		// 	state.projectTree
		// 		.find(bin => bin.id == state.bin.id)
		// 		.children.find(folder => folder.id == payload.parent_id && folder.slug == "matches")
		// 		.children.find(match => match.id == payload.old_id).id = payload.id;
		// },
		SET_TOTAL_IMAGES_UPLOAD_SIZE: (state, payload) => {
			state.totalImagesUploadSize = payload;
		},
		UPDATE_IMAGES_UPLOAD_PROGRESS: (state, payload) => {
			// if (!state.imagesUploadProgress[payload.key]) {
			// 	state.imagesUploadProgress.push(payload.value);
			// } else {
			// }
			state.imagesUploadProgress[payload.key] = payload.value;
		},
		RESET_IMAGES_UPLOAD_PROGRESS: state => {
			state.imagesUploadProgress = [];
		},
		ADD_IMAGE_UPLOAD_RESPONSE: (state, payload) => {
			state.imageUploadResponses.push(payload);
		},
		RESET_IMAGE_UPLOAD_RESPONSES: state => {
			state.imageUploadResponses = [];
		},
		SET_CANDIDATES_UPLOAD_LIST: (state, payload) => {
			state.candidatesUploadList = payload;
		},
		SET_PROJECTS_FEATURED_IMAGE: (state, payload) => {
			let objectURL = null;

			if (payload.blob && !state.projectsFeaturedImage[payload.id]) {
				objectURL = URL.createObjectURL(payload.blob);

				let data = {
					blob: payload.blob,
					url: objectURL,
				};

				Vue.set(state.projectsFeaturedImage, payload.id, data);
			}
		},
		SET_OPEN_PROJECT_TREE: (state, payload) => {
			state.openProjectTree = payload;
		},
		ADD_TAG: () => {
		},
		REMOVE_TAG: () => {
		},
		ADD_FILTER: (state, payload) => {
			state.appliedFilters.push(payload);
		},
		UPDATE_FILTER: (state, payload) => {
			Vue.set(state.appliedFilters, payload.index, payload.data);
		},
		DELETE_FILTER: (state, payload) => {
			state.appliedFilters = state.appliedFilters.filter((filter, index) => index !== payload);
		},
		SET_PROJECT_TREE_SEARCH: (state, payload) => {
			if (payload == "" || payload == null) {
				state.projectTreeSearch = "*";
			} else {
				state.projectTreeSearch = payload;
			}
		},
		SET_PROJECT_TREE_COMPONENT: (state, payload) => {
			state.projectTreeUpdateAll = payload;
		},
		SET_LAST_OPEN_PROJECT_TREE: (state, projectTree) => {
			if (state.projectTreeSearch == "*" && state.appliedFilters.length == 0) {
				state.openProjectTree = [...state.lastOpenProjectTree];
				state.allOpenProjectTree = false;
			} else {
				if (!state.allOpenProjectTree) {
					state.allOpenProjectTree = true;
					state.lastOpenProjectTree = [...state.openProjectTree];
					projectTree.updateAll(true);
				}
			}
		},
		SET_LAST_PROJECT: (state, payload) => {
			state.lastProject = payload;
		},
		SET_PROJECT_SWITCH: (state, payload) => {
			state.projectSwitch = payload;
		},
		SET_MODAL_SELECTED_PROJECT: (state, payload) => {
			state.modalSelectedProject = payload;
		},
		UPDATE_FILE_THUMBNAIL: () => {
		},
		// UPDATE_PROJECT_THUMBNAIL: () => {},
		ADD_DELETING_PROJECT: (state, project_id) => {
			state.deletingProjects.push(project_id);
		},
		SET_TOTAL_UPLOAD_FILES: (state, payload) => {
			state.totalUploadFiles = payload;
		},
		SET_PROCESSED_FILES_FOR_UPLOAD: state => {
			state.processedFilesForUpload++;
		},
		RESET_PROCESSED_FILES_FOR_UPLOAD: state => {
			state.processedFilesForUpload = 0;
		},
		SET_FILES_UPLOADED: state => {
			state.filesUploaded++;
		},
		RESET_FILES_UPLOADED: state => {
			state.filesUploaded = 0;
		},
		SET_UPLOAD_STATUS: (state, payload) => {
			state.uploadStatus = payload;
		},
		SET_FAILED_UPLOADS_LIST: (state, payload) => {
			state.failedUploadsList = payload;
		},
		SET_CHANNEL_TOKEN: (state, payload) => {
			state.channelToken = payload;
		},
		// SET_CHANNEL: (state, payload) => {
		// 	state.channels.push(payload);
		// }
		ADD_NEURAL_FILM_AI_UNPROCESSED_FILE: (state, payload) => {
			state.neuralFilmAIUnprocessedList.push(payload)
		},
		RESET_NEURAL_FILM_AI_UNPROCESSED_LIST: state => {
			state.neuralFilmAIUnprocessedList = [];
		},
		SET_NEURAL_FILM_AI_PROCESSING_FILE: (state, payload) => {
			state.neuralFilmAIProcessingFile = payload;
		},
		ADD_SAVE_ALL_AS_CANDIDATES_UNPROCESSED_FILE: (state, payload) => {
			state.saveAllAsCandidatesUnprocessedList.push(payload)
		},
		RESET_SAVE_ALL_AS_CANDIDATES_UNPROCESSED_LIST: state => {
			state.saveAllAsCandidatesUnprocessedList = [];
		},
		SET_SAVE_ALL_AS_CANDIDATES_PROCESSING_FILE: (state, payload) => {
			state.saveAllAsCandidatesProcessingFile = payload;
		},
		SET_EXIF: (state, payload) => {
			state.exif = payload;
		}
	},
	actions: {
		updateLastOpenProjectTree: ({ commit }, projectTree) => {
			commit("SET_LAST_OPEN_PROJECT_TREE", projectTree);
		},
		fetchProjects: async ({ commit, rootState, state }) => {
			await Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/projects`)
				.then(response => {
					let projects = response.data;

					// admins
					if (rootState.User.account.role_id == 3) {
						projects = projects.filter(project => {
							if (project.users.map(user => user.id).includes(rootState.User.user.id)) return project;
						});
					}

					commit("SET_PROJECTS", projects);

					if (rootState.Projects.selectedProject) {
						const newSelectedProject = projects.find(project => project.id === rootState.Projects.selectedProject.id);

						commit("SET_SELECTED_PROJECT", newSelectedProject);
					}

					if (state.project_id) commit("SET_ACTIVE_PROJECT");
				})
				.catch(err => console.log(err.response));
		},
		selectProject: ({ commit }) => {
			commit("SET_ACTIVE_PROJECT");
		},
		setProjectId: ({ commit }, payload) => {
			commit("SET_SELECTED_PROJECT_ID", payload);
		},
		selectProjectSettings: ({ commit }, payload) => {
			commit("SET_PROJECT_SETTINGS", payload);
		},
		createProject: ({ commit, rootState }, payload) => {
			let data = {
				name: payload.name,
			};

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects`, data)
				.then(response => {
					commit("PROJECT_CREATED", response.data);
					return response;
				})
				.catch(err => err.response);
		},

		deleteProject: ({ commit, rootState }, payload) => {
			commit("ADD_DELETING_PROJECT", payload.project_id);
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${payload.project_id}`)
				.catch(err => console.log(err.response));
		},

		updateProjectName: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.patch(`accounts/${rootState.User.account.id}/projects/${payload.project_id}`, {
					name: payload.name,
				})
				.then(response => {
					commit("PROJECT_NAME_UPDATED", response.data);
				})
				.catch(err => console.log(err.response));
		},

		assignUsers: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${payload.project_id}/users`, {
					account_ids: payload.account_ids,
				})
				.then(response => {
					commit("USERS_ASSIGNED", response.data);
				})
				.catch(err => console.log(err.response));
		},

		removeUsers: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${payload.project_id}/users`, {
					data: {
						account_ids: payload.account_ids,
					},
				})
				.then(response => {
					commit("USERS_REMOVED", response.data);
				})
				.catch(err => console.log(err.response));
		},

		assignGroups: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${payload.project_id}/users`, {
					group_name: payload.group_name,
				})
				.then(response => {
					commit("GROUPS_ASSIGNED", response.data);
				})
				.catch(err => console.log(err.response));
		},

		removeGroups: ({ commit, rootState }, payload) => {
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${payload.project_id}/users`, {
					data: {
						group_name: payload.group_name,
					},
				})
				.then(response => {
					commit("GROUPS_REMOVED", response.data);
				})
				.catch(err => console.log(err.response));
		},
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
		createBin: ({ commit, rootState, state }, payload) => {
			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/folders`, {
					name: payload,
				})
				.then(response => {
					commit("CREATE_BIN");
					return response;
				})
				.catch(err => console.log(err.response));
		},
		selectBin: ({ commit, getters }, id) => {
			commit("SET_PREVIOUS_BIN");
			commit(
				"SET_BIN",
				getters.bins.find(bin => bin.id == id)
			);
		},
		setAction: ({ commit }, payload) => {
			commit("SET_ACTION", payload);
		},
		updateBin: ({ commit, rootState, state }, name) => {
			return Vue.prototype.$apiService
				.patch(`accounts/${rootState.User.account.id}/projects/${state.project.id}/folders/${state.action.data.id}`, {
					name: name,
				})
				.then(response => {
					commit("BIN_UPDATED");
				})
				.catch(err => console.log(err.response));
		},
		deleteBin: ({ commit, rootState, state }) => {
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${state.project.id}/folders/${state.action.data.id}`)
				.then(response => {
					commit("BIN_DELETED");
				})
				.catch(err => console.log(err.response));
		},
		fetchFilesList: async ({ commit, rootState, state }) => {
			return await Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files`)
				.then(response => {
					commit("SET_FILES", response.data);
				})
				.catch(err => console.log(err.response));
		},
		fetchFile: ({ rootState, state }, url) => {
			return Vue.prototype.$S3Service
				.get(url, {
					responseType: "blob",
				})
				.then(response => {
					return response.data;
				})
				.catch(err => console.log(err.response));
		},
		// fetchFile: ({ rootState, state }, file_id) => {
		// 	return Vue.prototype.$apiService
		// 		.get(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files/${file_id}/content`, {
		// 			responseType: "blob",
		// 		})
		// 		.then(response => {
		// 			return response.data;
		// 		})
		// 		.catch(err => console.log(err.response));
		// },
		// updateFileName: ({ commit, state, rootState }, payload) => {
		// 	return Vue.prototype.$apiService
		// 		.patch(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files/${state.action.data.id}`, {
		// 			name: payload.name,
		// 		})
		// 		.then(() => {
		// 			commit("FILE_NAME_UPDATED");
		// 		})
		// 		.catch(err => console.log(err.response));
		// },

		refreshProjectTree: async ({commit, state, getters, rootState, dispatch}) => {
			await dispatch("File/Media/fetchFromLocalStorage", null, {root: true});
			const lastStates = await imagesStateStore.getItems();
			const mediaClone = cloneDeep(rootState.File.Media.mediaList);
			let mediaList = [];

			for (const [uuid, media] of Object.entries(mediaClone)) {
				media.id = uuid;
				media.key = uuid;
				media.type = 'media';

				if (lastStates[media.id]?.blocks.length > 0) {
					media.IDT = lastStates[media.id].blocks[1].values;
				}

				mediaList.push(media);
			}

			mediaList = mediaList.sort((a, b) => a.name.localeCompare(b.name))
			commit("SET_PROJECT_TREE", mediaList);
			if (state.initialProjectTreeRefresh) commit('SET_INITIAL_PROJECT_TREE_REFRESH', false);

			vm.$root.projectTree.$data.selectedFiles.forEach((selectedFile, key) => {
				if (selectedFile) {
					vm.$root.projectTree.$data.selectedFiles[key] = getters.assetById(selectedFile.id, selectedFile.type);
				}
			})
		},

		postUploadingFilesData: ({ rootState, state }, payload) => {
			let formdata = new FormData();
			payload.forEach((file, key) => {
				formdata.append(`files[${key}][folder_id]`, file.parent_id ? file.parent_id : state.action.id);
				formdata.append(`files[${key}][type]`, file.type);
				formdata.append(`files[${key}][name]`, file.name);
				formdata.append(`files[${key}][size]`, file.size);
				formdata.append(`files[${key}][thumbnail_name]`, file.thumbnail_name);
				formdata.append(`files[${key}][thumbnail_size]`, file.thumbnail_size);

				if (file.commentMediaUpload) {
					formdata.append(`files[${key}][comment_upload]`, 1);
				}

				if (file.type == "match") {
					formdata.append(`files[${key}][blocks_name]`, file.blocksFile.name);
					formdata.append(`files[${key}][blocks_size]`, file.blocksFile.size);
					formdata.append(`files[${key}][imageIDTLMT_name]`, file.imageIDTLMT.name);
					formdata.append(`files[${key}][imageIDTLMT_size]`, file.imageIDTLMT.size);

					file.luts.forEach((lut, lutIndex) => {
						formdata.append(`files[${key}][luts][${lutIndex}][name]`, lut.name);
						formdata.append(`files[${key}][luts][${lutIndex}][size]`, lut.size);
					});
				}
			});

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files`, formdata)
				.then(response => {
					return response.data;
				})
				.catch(err => {
					console.log(err.response);
					return err;
				});
		},
		uploadToS3: ({ state, dispatch, commit }, payload) => {
			let config = null;
			if (payload.uploadProgress) {
				config = {
					onUploadProgress: progressEvent => {
						commit("UPDATE_IMAGES_UPLOAD_PROGRESS", {
							key: payload.key,
							value: progressEvent.loaded,
						});

						var totalImagesUploaded = 0;
						state.imagesUploadProgress.forEach(value => {
							totalImagesUploaded += value;
						});

						let percentCompleted = Math.round((totalImagesUploaded / state.totalImagesUploadSize) * 100);
						// console.log(totalImagesUploaded, state.totalImagesUploadSize, percentCompleted);
						dispatch("Loader/setImportProgress", percentCompleted, { root: true });
					},
				};
			}

			return Vue.prototype.$S3Service
				.put(payload.url, payload.file, config)
				.then(response => {
					// console.log(response);
					return response;
				})
				.catch(err => {
					console.log(err.response);
					return err;
				});
		},
		updateFilesUploadStatus: async ({ rootState, state, dispatch }, payload) => {
			let filesUploadBatches = [];
			let batchMaxSize = 100;
			let batchList = [];

			// creating batches
			payload.forEach((file, key) => {
				if (batchList.length < batchMaxSize) {
					batchList.push(file);
				}

				if (batchList.length == batchMaxSize || key == payload.length - 1) {
					filesUploadBatches.push(batchList);
					batchList = [];
				}
			});

			let promises = [];
			let failedFiles = [];

			filesUploadBatches.forEach(batch => {
				let params = new URLSearchParams();
				batch.forEach((id, key) => {
					params.append(`files[${key}][id]`, id);
					params.append(`files[${key}][status]`, "uploaded");
				});

				promises.push(
					Vue.prototype.$apiService
						.patch(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files-status`, params)
						.then(response => {
							response.data.forEach(file => {
								if (!['image', 'candidate', 'match'].includes(file.type)) return;
								if (file.status == 'failed') failedFiles.push(file);
							})
						})
						.catch(err => console.log(err.response))
				);
			});

			await Promise.all(promises);

			if (failedFiles.length > 0) {
				dispatch(
					"setFailedUploadsList",
					failedFiles
				);
				UI.showModal(UI.modals.files.failedUploading);
			}
		},
		postMatch: ({ rootState, state, getters }, payload) => {
			let formdata = new FormData();
			formdata.append("files[0][folder_id]", getters.folderIdBySlug("matches"));
			formdata.append("files[0][type]", "match");
			formdata.append("files[0][file]", payload.file);
			formdata.append("files[0][thumbnail]", payload.thumbnail);

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files`, formdata)
				.then(response => {
					return response.data[0];
				})
				.catch(err => console.log(err.response));
		},
		setImage: ({ commit }, payload) => {
			commit("SET_IMAGE", payload);
		},
		setCurrentFile: ({ commit }, payload) => {
			commit('SET_PREVIOUS_FILE');
			commit('SET_CURRENT_FILE', payload);
		},
		fetchSystemFiles: ({ commit }, payload) => {
			return Vue.prototype.$apiService
				.get('system-files', {
					params: {
						block: payload.block
					}
				})
				.then(response => {
					return response.data;
				})
				.catch(err => console.log(err.response));
		},
		fetchSystemLuts: ({ commit }, payload) => {
			return Vue.prototype.$apiService
				.get(`system-luts`, {
					params: {
						type: payload.type,
						category: payload.category,
					},
				})
				.then(response => {
					commit("FECTH_SYSTEM_LUTS", response.data);
					return response.data;
				})
				.catch(err => console.log(err.response));
		},
		moveTo: ({ commit, rootState, state }, payload) => {
			return Vue.prototype.$apiService
				.patch(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files/${payload.file_id}/manage`, {
					action: payload.action,
					file_ids: payload.file_ids,
				})
				.then(response => {
					commit("MOVED_TO", response.data);
				})
				.catch(err => {
					alert("Failed to move the file");
					console.log(err.response);
				});
		},
		deleteFile: ({ commit, rootState, state }, payload) => {
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files/${payload.file_id}`, {
					data: {
						folder_id: payload.folder_id,
						file_ids: payload.file_ids,
					},
				})
				.then(response => {
					commit("FILE_DELETED");
				})
				.catch(err => console.log(err.response));
		},
		postUploadingCandidatesData: ({ commit, rootState, state }, payload) => {
			let formdata = new FormData();
			payload.forEach((candidate, key) => {
				formdata.append(`files[${key}][name]`, candidate.name);
				formdata.append(`files[${key}][size]`, candidate.size);
				formdata.append(`files[${key}][thumbnail_name]`, candidate.thumbnail_name);
				formdata.append(`files[${key}][thumbnail_size]`, candidate.thumbnail_size);
				formdata.append(`files[${key}][image_name]`, candidate.image_name);
				formdata.append(`files[${key}][image_size]`, candidate.image_size);
				formdata.append(`files[${key}][parent_id]`, candidate.parent_id);
				candidate.luts.forEach((lut, lutKey) => {
					formdata.append(`files[${key}][luts][${lutKey}][name]`, lut.name);
					formdata.append(`files[${key}][luts][${lutKey}][size]`, lut.size);
				});
			});

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/candidates`, formdata)
				.then(response => {
					commit("POST_CANDIDATES_DATA");
					return response.data;
				})
				.catch(err => console.log(err.response));
		},
		selectMatch: ({ commit, getters }, payload) => {
			// commit("SELECT_MATCH", getters.matchById(id));
			commit("SELECT_MATCH", payload);
		},
		deselectMatch: ({ commit }) => {
			commit("DESELECT_MATCH");
		},
		setImagesUploadList: async ({ commit }) => {
			await IDB.uploadImagesStore.getItems().then(results => {
				commit("SET_IMAGES_UPLOAD_LIST", results);
			});
		},
		setImagesStoreList: async ({ commit }) => {
			await IDB.imagesStore.getItems().then(results => {
				commit("SET_IMAGES_STORE_LIST", results);
			});
		},
		setMatchesUploadList: async ({ commit }) => {
			await IDB.uploadMatchesStore.getItems().then(results => {
				commit("SET_MATCHES_UPLOAD_LIST", results);
			});
		},
		setMatchesStoreList: async ({ commit }) => {
			await IDB.matchesStore.getItems().then(results => {
				commit("SET_MATCHES_STORE_LIST", results);
			});
		},
		// addUploadingMatchToFiles: ({ commit }, payload) => {
		// 	commit("ADD_UPLOADING_MATCH", payload);
		// },
		updateMatchInFiles: ({ commit }, payload) => {
			commit("UPDATE_MATCH", payload);
		},
		setActiveCandidate: ({ commit }, id) => {
			commit("SET_CANDIDATE", id);
		},
		// removeMatchFromFiles: ({commit}, id) => {
		// 	commit("REMOVE_MATCH_FROM_FILES", id);
		// },
		updateTotalImagesUploadSize: ({ commit }, payload) => {
			// var size = 0;
			// return IDB.uploadImagesStore
			// 	.iterate(function(value) {
			// 		size += value.file.size;
			// 	})
			// 	.then(function() {
			// 		commit("SET_TOTAL_IMAGES_UPLOAD_SIZE", size);
			// 	});
			commit("SET_TOTAL_IMAGES_UPLOAD_SIZE", payload);
		},
		resetTotalImagesUploaded: ({ commit }) => {
			commit("RESET_IMAGES_UPLOAD_PROGRESS");
		},
		addImageUploadResponse: ({ commit }, payload) => {
			commit("ADD_IMAGE_UPLOAD_RESPONSE", payload);
		},
		resetImageUploadResponses: ({ commit }) => {
			commit("RESET_IMAGE_UPLOAD_RESPONSES");
		},
		setCandidatesUploadList: async ({ commit }) => {
			await IDB.uploadCandidatesStore.getItems().then(data => {
				let payload = [];
				Object.keys(data).forEach(key => payload.push(data[key]));
				commit("SET_CANDIDATES_UPLOAD_LIST", payload);
			});
		},

		setProjectFeaturedImage: async ({ commit }, payload) => {
			commit("SET_PROJECTS_FEATURED_IMAGE", {
				id: payload.project_id,
				blob: payload.blob,
			});
		},

		setProjectsFeaturedImage: async ({ commit, state, dispatch }, projects) => {
			for await (const project of projects) {
				let storeData = await IDB.projectsThumbnailsStore.getItem(project.id);
				if (storeData && !storeData.blob) continue;

				commit("SET_PROJECTS_FEATURED_IMAGE", {
					id: project.id,
					blob: storeData ? storeData.blob : null,
				});

				if (!storeData && project.thumbnail) {
					if (state.projectsFeaturedImage[project.id] !== undefined) continue; // fetch/set only once

					dispatch("fetchFile", project.thumbnail.presignedURL).then(async blob => {
						await IDB.projectsThumbnailsStore.setItem(project.id, {
							blob,
						});

						commit("SET_PROJECTS_FEATURED_IMAGE", {
							id: project.id,
							blob,
						});
					});
				}
			}
		},

		fetchThumbnail: async ({ commit, dispatch, state }, payload) => {
			let thumbnail = await IDB.thumbnailsStore.getItem(payload.file.id);
			if (!thumbnail) {
				let blob = await dispatch("fetchFile", payload.file.thumbnail.presign_url);
				thumbnail = {
					project_id: payload.project_id,
					// folder_id: payload.folder.id,
					blob,
				};

				IDB.thumbnailsStore.setItem(payload.file.id, thumbnail);
			}

			return thumbnail;
		},

		// fetchThumbnails: async ({ commit, state, dispatch }) => {
		// 	let filesList = [];
		// 	let thumbnailsList = [];
		// 	let bufferList = [];
		//
		// 	state.projectTree.forEach(bin => {
		// 		let mediaFolder = bin.children.find(folder => folder.slug == "media");
		// 		let matchFolder = bin.children.find(folder => folder.slug == "matches");
		// 		let candidateFolders = mediaFolder.children.filter(item => item.name == "Candidates");
		// 		let archiveFolder = bin.children.find(folder => folder.slug == "archive");
		// 		let trashFolder = bin.children.find(folder => folder.slug == "trash");
		//
		// 			mediaFolder.children.forEach(file => {
		// 			if (file.name !== "Candidates" && !state.fileThumbnailObjects[file.id]) {
		// 				filesList.push({
		// 					file,
		// 					folder: mediaFolder,
		// 				})
		// 			}
		// 		});
		//
		// 		// Matches
		// 		matchFolder.children.forEach(file => {
		// 			if (!state.fileThumbnailObjects[file.id]) {
		// 				filesList.push({
		// 					file,
		// 					folder: matchFolder
		// 				})
		// 			}
		// 		});
		//
		// 		// Candidates
		// 		if (candidateFolders.length) {
		// 			candidateFolders.forEach(candidateFolder => {
		// 				candidateFolder.children.forEach(file => {
		// 					if (!state.fileThumbnailObjects[file.id]) {
		// 						filesList.push({
		// 							file,
		// 							folder: file.parent_file
		// 						})
		// 					}
		// 				});
		// 			});
		// 		}
		//
		// 		// Archive
		// 		archiveFolder.children.forEach(subfolder => {
		// 			subfolder.children.forEach(file => {
		// 				if (file.type == "image" && !state.fileThumbnailObjects[file.id]) {
		// 					filesList.push({
		// 						file,
		// 						folder: mediaFolder
		// 					})
		// 				}
		//
		// 				if (file.type == "match" && !state.fileThumbnailObjects[file.id]) {
		// 					filesList.push({
		// 						file,
		// 						folder: matchFolder
		// 					})
		// 				}
		//
		// 				if (file.type == "candidate" && !state.fileThumbnailObjects[file.id]) {
		// 					filesList.push({
		// 						file,
		// 						folder: mediaFolder
		// 					})
		// 				}
		// 			});
		// 		});
		//
		// 		// Archive
		// 		trashFolder.children.forEach(subfolder => {
		// 			subfolder.children.forEach(file => {
		// 				if (file.type == "image" && !state.fileThumbnailObjects[file.id]) {
		// 					filesList.push({
		// 						file,
		// 						folder: mediaFolder
		// 					})
		// 				}
		//
		// 				if (file.type == "match" && !state.fileThumbnailObjects[file.id]) {
		// 					filesList.push({
		// 						file,
		// 						folder: matchFolder
		// 					})
		// 				}
		//
		// 				if (file.type == "candidate" && !state.fileThumbnailObjects[file.id]) {
		// 					filesList.push({
		// 						file,
		// 						folder: mediaFolder
		// 					})
		// 				}
		// 			});
		// 		});
		// 	});
		//
		// 	if (filesList.length == 0) return;
		//
		// 	let thumbnailsStoreData = await IDB.thumbnailsStore.getItems(filesList.map(e => e.file.id.toString()));
		// 	filesList.forEach(item => {
		// 		if (thumbnailsStoreData[item.file.id]) {
		// 			thumbnailsList.push(thumbnailsStoreData[item.file.id].blob);
		// 		} else {
		// 			thumbnailsList.push(dispatch('fetchThumbnail', item));
		// 		}
		// 	})
		//
		// 	thumbnailsList = await Promise.all(thumbnailsList);
		//
		// 	filesList.forEach((item, key) => {
		// 		bufferList.push({
		// 			file_id: item.file.id,
		// 			objectURL: URL.createObjectURL(thumbnailsList[key])
		// 		})
		// 	})
		//
		// 	commit("SET_FILE_THUMBNAIL_OBJECT", bufferList);
		// },

		setThumbnailObject: ({ commit }, payload) => {
			commit("SET_FILE_THUMBNAIL_OBJECT", payload);
		},

		updateThumbnailObject: ({ commit }, payload) => {
			commit("REVOKE_FILE_THUMBNAIL_OBJECT", payload.file_id);

			commit("SET_FILE_THUMBNAIL_OBJECT", {
				file_id: payload.file_id,
				objectURL: URL.createObjectURL(payload.blob)
			})
		},

		openProjectTree: ({ commit, state }, payload = null) => {
			// if (!payload) {
			// 	if (state.projectTree.length == 1 && state.projectTree[0].children[0].children.length == 0) {
			// 		commit("SET_OPEN_PROJECT_TREE", [state.projectTree[0].id]);
			// 	}
			// } else {
			// 	commit("SET_OPEN_PROJECT_TREE", payload);
			// }
			commit("SET_OPEN_PROJECT_TREE", payload);
		},

		setProjectTreeComponent: ({ commit }, payload) => {
			commit("SET_PROJECT_TREE_COMPONENT", payload);
		},

		openAllProjectTree: ({ state }) => {
			state.projectTreeUpdateAll(true);
		},

		setCopyToProjectTree: ({ commit, state }, type) => {
			let projectTree = cloneDeep(state.projectTree);
			if (type == "image" || type == "match") {
				let slug = type == "image" ? "media" : "matches";
				projectTree = projectTree.filter(bin => {
					// can't copy to origin bin
					if (
						bin.children
							.find(folder => folder.slug == slug)
							.children.find(
							file => state.action.data.map(e => e.id).includes(file.id)
							// file => state.action.data.map(e => e.id).includes(file.id) || state.action.data.map(e => e.name).includes(file.name)
						)
					)
						return false;
					else return bin;
				});
				projectTree.forEach(bin => {
					bin.files = bin.children;
					bin.children = undefined;
				});
			} else if (type == "candidate") {
				projectTree.forEach(bin => {
					bin.children = bin.children
						.find(folder => folder.slug == "media")
						.children.filter((file, index, filesArray) => {
							if (file.type == "image") {
								if (state.action.data.map(selectedCandidate => selectedCandidate.parent_file.id).includes(file.id)) return false;
								// can not copy to origin
								else if (
									// if destination image already has that candidate. NOTE: this can be removed, since cloned candidate has a new timestamp
									filesArray[index + 1] &&
									filesArray[index + 1].name == "Candidates" &&
									filesArray[index + 1].children.find(candidate =>
										state.action.data.map(selectedCandidate => selectedCandidate.name).includes(candidate.name)
									)
								)
									return false;
								else return file;
							}
						});
				});

				projectTree = projectTree.filter(bin => bin.children.length > 0);
			}

			commit("SET_COPY_TO_PROJECT_TREE", projectTree);
		},

		setCopyCandidateFromProjectTree: ({ commit, state }) => {
			let projectTree = cloneDeep(state.projectTree);
			projectTree.forEach(bin => {
				let candidates = [];

				bin.children
					.find(folder => folder.slug == "media")
					.children.filter(folder => folder.name == "Candidates")
					.forEach(candidatesList => {
						candidates.push(...candidatesList.children);
					});

				bin.children = candidates;
			});

			projectTree = projectTree.filter(bin => bin.children.length > 0);

			commit("SET_COPY_CANDIDATE_FROM_PROJECT_TREE", projectTree);
		},

		copyFile: ({ commit, rootState, state }, payload) => {
			let formdata = new FormData();
			formdata.append("type", payload.type);
			formdata.append("object_id", payload.destination);
			// formdata.append("name", "renamed.jpg");

			payload.file_ids.forEach((file_id, key) => {
				formdata.append(`file_ids[${key}]`, file_id);
			});

			return new Promise(resolve => {
				Vue.prototype.$apiService
					.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files/${payload.file_id}/clone`, formdata)
					.then(response => {
						resolve();
					})
					.catch(err => console.log(err.response));
			});
		},

		copyCandidateFrom: ({ rootState, state }, payload) => {
			let formdata = new FormData();
			formdata.append("candidate_id", payload.candidate_id);

			payload.file_ids.forEach((file_id, key) => {
				formdata.append(`file_ids[${key}]`, file_id);
			});

			return new Promise(resolve => {
				Vue.prototype.$apiService
					.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/files/${payload.file_id}/clone-from`, formdata)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => console.log(err.response));
			});
		},

		setApplyGradeToProjectTree: ({ commit, state }) => {
			let projectTree = cloneDeep(state.projectTree);

			projectTree.forEach(bin => {
				bin.children = bin.children
					.find(folder => folder.slug == "media")
					.children.filter(file => {
						if (file.type == "image") {
							return file;
						}
					});
			});

			projectTree = projectTree.filter(bin => bin.children.length > 0);

			commit("SET_APPLY_GRADE_TO_PROJECT_TREE", projectTree);
		},

		setModalImagesProjectTree: ({ commit, state }) => {
			let projectTree = cloneDeep(state.projectTree);
			projectTree.forEach(bin => {
				let images = [];

				bin.children
					.find(folder => folder.slug == "media").children
					.forEach(file => {
						if (file.type == 'image') {
							images.push(file);
						}
					});

				bin.children = images;
			});

			projectTree = projectTree.filter(bin => bin.children.length > 0);

			commit("SET_MODAL_IMAGES_PROJECT_TREE", projectTree);
		},

		setApplyGradeFromCandidateProjectTree: ({ commit, state, rootState }) => {

			commit("SET_APPLY_GRADE_FROM_CANDIDATE_PROJECT_TREE", rootState.UI.candidates);
		},

		setApplyGradeFromMatchProjectTree: async ({ commit, getters, dispatch, rootState }) => {
			const list = [];
			for (const [uuid, match] of Object.entries(getters.allMatches)) {
				list.push(match)
			}
			commit("SET_APPLY_GRADE_FROM_MATCH_PROJECT_TREE", list);
		},

		addTag: async ({ commit, rootState, state }, payload) => {
			let formdata = new FormData();
			payload.file_ids.forEach((file_id, key) => {
				formdata.append(`file_ids[${key}]`, file_id);
			});
			formdata.append(`tags[0][name]`, payload.tag_name);
			formdata.append(`tags[0][value]`, payload.tag_value);

			return await Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/tags`, formdata)
				.then(response => {
					commit("ADD_TAG");
				})
				.catch(err => console.log(err.response));
		},
		removeTag: async ({ commit, rootState, state }, payload) => {
			return await Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/projects/${state.project.id}/tags`, {
					data: {
						file_ids: payload.file_ids,
						tags: [
							{
								name: payload.tag_name,
								value: payload.tag_value,
							},
						],
					},
				})
				.then(response => {
					commit("REMOVE_TAG");
				})
				.catch(err => console.log(err.response));
		},
		addFilter: ({ commit }, payload) => {
			commit("ADD_FILTER", payload);
		},
		updateFilter: ({ commit }, payload) => {
			commit("UPDATE_FILTER", payload);
		},
		deleteFilter: ({ commit }, payload) => {
			commit("DELETE_FILTER", payload);
		},
		updateProjectTreeSearch: ({ commit }, payload) => {
			commit("SET_PROJECT_TREE_SEARCH", payload);
		},
		setLastProject: ({ commit }, payload) => {
			commit("SET_LAST_PROJECT", payload);
		},
		setProjectSwitch: ({ commit }, payload) => {
			commit("SET_PROJECT_SWITCH", payload);
		},
		switchProject: async ({ state, dispatch, commit }) => {
			UI.projectSwitch();
			commit("REVOKE_THUMBNAIL_OBJECTS");
			dispatch("setProjectSwitch", true);
			dispatch("setLastProject", state.project.id);

			if (state.image) await lutify.storeLastState();
			lutify.pushLastStates(false, state.lastProject);

			dispatch("setImage", null);
			dispatch('setCurrentFile', null);
			dispatch('resetActiveBin');

			dispatch("UI/removeCandidates", null, { root: true });
			dispatch("UI/removeMatches", null, { root: true });

			blocks.removeAllDynamic();
			lutify.selectedIDT = null;
			lutify.selectedODT = null;
			vm.$store.dispatch("App/resetActiveIDT");

			dispatch('UI/setRightColumn', 'project', {root: true});
		},
		setModalSelectedProject: ({ commit }, payload) => {
			commit("SET_MODAL_SELECTED_PROJECT", payload);
		},
		postThumbnailData: ({ commit, state, rootState }, payload) => {
			let formdata = new FormData();
			formdata.append("thumbnail_name", payload.file.name);
			formdata.append("thumbnail_size", payload.file.size);

			let url = `accounts/${rootState.User.account.id}/projects/${state.project.id}/thumbnail`; // project thumbnail
			if (payload.file_id) url += `/${payload.file_id}`; // file thumbnail

			return Vue.prototype.$apiService
				.post(url, formdata)
				.then(response => {
					commit("UPDATE_FILE_THUMBNAIL");
					return response.data;
				})
				.catch(err => console.log(err.response));
		},
		// updateProjectThumbnail: ({ commit, state, rootState }, file) => {
		// 	let formdata = new FormData();
		// 	formdata.append("thumbnail", file);

		// 	return Vue.prototype.$apiService
		// 		.post(`accounts/${rootState.User.account.id}/projects/${state.project.id}/thumbnail`, formdata)
		// 		.then(response => {
		// 			console.log("project thumbnail", response);
		// 			commit("UPDATE_PROJECT_THUMBNAIL");
		// 		})
		// 		.catch(err => console.log(err.response));
		// },
		// fetchProjectsThumbnails: ({ rootState }, payload) => {
		// 	return new Promise(resolve => {
		// 		Vue.prototype.$apiService
		// 			.get(`accounts/${rootState.User.account.id}/projects/${payload.project_id}/files/${payload.file_id}/content`, {
		// 				responseType: "blob",
		// 			})
		// 			.then(response => {
		// 				resolve(response.data);
		// 			})
		// 			.catch(err => console.log(err.response));
		// 	});
		// },

		fetchFilesQuota: ({ rootState }) => {
			return new Promise(resolve => {
				Vue.prototype.$apiService
					.get(`accounts/${rootState.User.account.id}/files-quota`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => console.log(err.response));
			});
		},
		setTotalUploadFiles: ({ commit }, payload) => {
			commit("SET_TOTAL_UPLOAD_FILES", payload);
		},
		setProcessedFilesForUpload: ({ commit }) => {
			commit("SET_PROCESSED_FILES_FOR_UPLOAD");
		},
		resetProcessedFilesForUpload: ({ commit }) => {
			commit("RESET_PROCESSED_FILES_FOR_UPLOAD");
		},
		setFilesUploaded: ({ commit }) => {
			commit("SET_FILES_UPLOADED");
		},
		resetFilesUploaded: ({ commit }) => {
			commit("RESET_FILES_UPLOADED");
		},
		setUploadStatus: ({ commit }, payload) => {
			commit("SET_UPLOAD_STATUS", payload);
		},
		setFailedUploadsList: ({ commit }, payload) => {
			commit("SET_FAILED_UPLOADS_LIST", payload);
		},

		fetchChannelToken: async ({ commit, state, rootState }) => {
			return await Vue.prototype.$apiService
				.get(`accounts/${rootState.User.account.id}/projects/${state.project.id}/channel-token`)
				.then(response => {
					commit('SET_CHANNEL_TOKEN', response.data);
				})
				.catch(err => console.log(err.response));
		},

		resetActiveBin: ({ commit }) => {
			commit('RESET_ACTIVE_BIN');
		},

		setExif: ({commit}, payload) => {
			commit('SET_EXIF', payload);
		},
	},
	getters: {
		project: state => id => {
			if (state.projects) return state.projects.find(project => project.id == id);
		},

		selectedProject: state => {
			return state.selectedProject;
		},

		projectsFromActiveOrganisation: (state, getters, rootState) => {
			return state.projects;
		},

		binName: state => {
			if (state.bin) return state.bin.name;
		},
		binById: state => bin_id => {
			return state.projectTree.find(bin => bin.id == bin_id);
		},
		binNameById: state => bin_id => {
			return state.projectTree.find(bin => bin.id == bin_id).name;
		},
		processingBinName: state => {
			if (state.action.data) return state.action.data.name;
		},
		folderIdBySlug: state => (slug, bin_id) => {
			if (!bin_id) bin_id = state.bin.id;
			return state.projectTree.find(bin => bin.id == bin_id).children.find(folder => folder.slug == slug).id;
		},
		folderBySlug: state => (slug, bin_id) => {
			if (!bin_id) bin_id = state.bin.id;
			return state.projectTree.find(bin => bin.id == bin_id).children.find(folder => folder.slug == slug);
		},
		// processingFolderIdBySlug: state => slug => {
		// 	return state.action.data.sub_folders.find(folder => folder.slug == slug).id;
		// },
		// files: state => id => {
		// 	return state.files.find(folder => folder.id == id).files;
		// },
		bins: state => {
			if (state.files) return state.files.filter(item => item.type == "bin" || item.type == "main");
		},
		binFolders: state => parent_id => {
			return state.files.filter(item => item.type == "sub_level_0" && item.parent_id == parent_id);
		},
		candidates: state => file_id => {
			if (!file_id) file_id = state.image;
			let candidates = [];
			let parent_file = null;

			if (state.files.filter(folder => folder.type == "sub_level_1").find(item => item.files[0].id == file_id)) {
				candidates = state.files
					.filter(folder => folder.type == "sub_level_1")
					.find(item => {
						if (item.files[0].id == file_id) {
							parent_file = item.files[0];
							return item;
						}
					})
					.files.filter(file => file.type == "candidate" && !file.trashed_at && !file.archived_at);

				candidates.forEach(candidate => {
					candidate.parent_file = parent_file;
					candidate.parent_file.key = parent_file.id;
					candidate.key = `${candidate.id}-candidate`; // this value gets overwritten with correct one. NOTE maybe can be deleted?
				});
			}

			// let uploadingCandidatesList = state.candidatesUploadList.filter(candidate => candidate.parent_id == file_id);
			// uploadingCandidatesList.forEach(candidate => (candidate.parent_file = { id: candidate.parent_id }));

			// return [...candidates, ...uploadingCandidatesList];
			return [...candidates];
		},
		candidateParentFile: (state, getters) => candidate => {
			let parent_file;
			state.files
				.filter(folder => folder.type == "sub_level_1")
				.forEach(candidateFolder => {
					candidateFolder.files.find(file => {
						if (file.id == candidate.id) parent_file = candidateFolder.files[0];
					});
				});

			return parent_file;
		},
		matches: (state, getters) => {
			return state.projectTree
				.find(bin => bin.id == state.bin.id)
				.children.find(folder => folder.id == getters.folderIdBySlug("matches"))
				.children.filter(file => file.type == "match");
		},
		matchesNumber: (state, getters) => {
			return getters.matches.length;
		},
		allMatches: (state, getters, rootState, rootGetters) => {
			return rootState.UI.matches;
		},
		uploadingMatches: (state, getters) => {
			if (state.matchesUploadList)
				return Object.keys(state.matchesUploadList).filter(key => {
					if (state.matchesUploadList[key].parent_id == getters.folderIdBySlug("matches")) return state.matchesUploadList[key];
				});
			else return [];
		},
		// matchByName: (state, getters) => match_name => {
		// 	return state.files.find(folder => folder.id == getters.folderIdBySlug("matches")).files.find(file => file.name == match_name).id;
		// },
		matchById: (state, getters, rootState) => (id, bin_id) => {
			return getters.allMatches.find(match => match.id == id);
		},
		file: state => id => {
			return state.files.find(file => file.id == id);
		},
		trashedFiles: state => (id, type) => {
			if (!type) return state.files.find(folder => folder.slug == "trash" && folder.id == id).files;
			else return state.files.find(folder => folder.slug == "trash" && folder.id == id).files.filter(file => file.type == type);
		},
		archivedFiles: state => (id, type) => {
			if (!type) return state.files.find(folder => folder.slug == "archive" && folder.id == id).files;
			else return state.files.find(folder => folder.slug == "archive" && folder.id == id).files.filter(file => file.type == type);
		},
		projectsFeaturedImage: state => id => {
			if (state.projectsFeaturedImage[id]?.url) {
				return state.projectsFeaturedImage[id].url;
			} else return "assets/media/images/fylmai-site-logo-white-project.png";
		},
		isDefaultProjectImage: state => id => {
			if (state.projectsFeaturedImage[id]?.blob) return false;
			else return true;
		},
		thumbnail: state => id => {
			return state.fileThumbnailObjects[id];
		},
		tagStyleColor: state => (filter, value) => {
			return state.tags[filter].find(tag => tag.value == value).styleColor;
		},
		isProjectBeingDeleted: state => project_id => {
			// This can be removed because API now immediately flags the project as deleted and it don't index them
			if (state.projects.find(project => project.id == project_id)?.deleted_at) return true;
			if (state.deletingProjects.includes(project_id)) return true;
		},
		candidateById: (state, getters, rootState) => (id, folder_slug = 'media') => {
			let foundCandidate = null;

			state.projectTree.forEach(bin => {
				bin.children
					.find(folder => folder.slug == folder_slug)
					.children.forEach(file => {
					if (folder_slug == 'media' && file.name == "Candidates") {
						file.children.forEach(candidate => {
							if (candidate.id == id) foundCandidate = candidate;
						});
					}

					if (folder_slug == 'shared' && file.id == id ) foundCandidate = file;
				});
			});

			return foundCandidate;
		},
		imageById: (state, getters, rootState) => id => {
			let foundImage = null;

			state.projectTree.forEach(file => {
				if ((file.type == 'image' || file.type == 'media') && file.id == id) {
					foundImage = file;
				}
			});

			return foundImage;
		},
		imagesByBinId: state => bin_id => {
			if (!bin_id) bin_id = state.bin.id;

			if (state.projectTree.find(bin => bin.id == bin_id))
				return state.projectTree
					.find(bin => bin.id == bin_id)
					.children.find(folder => folder.slug == "media")
					.children.filter(file => file.type == "image");
			else return [];
		},

		fileHasTag: state => (file, tagName, value) => {
			if (file.tags) return file.tags.find(tag => tag.name == tagName && tag.pivot.value == value);
			else return false;
		},

		isCurrentFileShared: (state, getters) => {
			return getters.fileHasTag(state.currentFile, 'shared', 'shared');
		},

		assetById: (state, getters) => (file_id, file_type, folder_slug = 'media') => {
			if (file_type == 'media' || file_type == 'image') {
				return getters.imageById(file_id);
			} else if (file_type == 'candidate') {
				return getters.candidateById(file_id, folder_slug);
			} else if (file_type == 'match') {
				return getters.matchById(file_id);
			}
		},

		allMediaOfProject: state => {
			let mediaList = [];

			state.projectTree.forEach(bin => {
				bin.children.forEach(folder => {
					if (folder.slug == 'media') {
						folder.children.forEach(file => {
							if (file.type == 'image') {
								mediaList.push(file);
							}
						})
					}
				})
			})

			return mediaList;
		},

		allAssets: (state, getters, rootState) => bin_id => {
			if (!bin_id) bin_id = state.bin.id;

			let assetsList = [];
			if (rootState.User.account.role_id == 7) {
				state.projectTree.find(bin => bin.id == bin_id)
					.children.forEach(file => {
						assetsList.push(file);
					})
			} else {
				state.projectTree.find(bin => bin.id == bin_id)
					.children.forEach(folder => {
					if (folder.slug == 'media') {
						folder.children.forEach(file => {
							if (file.type == 'image') assetsList.push(file);
							else {
								file.children.forEach(candidate => {
									assetsList.push(candidate);
								})
							}
						})
					}

					if (folder.slug == 'matches') {
						folder.children.forEach(file => {
							assetsList.push(file);
						})
					}
				})
			}

			return assetsList;
		},

		userOfActiveProject: state => user_id => {
			return state.project.users.find(user => user.id == user_id);
		},

		userOfProject: state => (user_id, project_id) => {
			return state.projects.find(project => project.id == project_id).users.find(user => user.id == user_id);
		},

		newAutoCandidateName: (state, getters) => {
			let candidatesOfImage = getters.candidates();
			let takenCandidateNames = candidatesOfImage.map(candidate => stripTimestampAndExtension(candidate.name));
			let newCandidateName = 'v1';

			for (let i = 1; i < 100; i++) {
				if (!takenCandidateNames.includes(`v${i}`)) {
					newCandidateName = `v${i}`;
					break;
				}
			}

			return newCandidateName;
		}
	},
};

export default Projects;
